import { render, staticRenderFns } from "./TypeEdit.vue?vue&type=template&id=174fd462&scoped=true"
import script from "./TypeEdit.vue?vue&type=script&lang=js"
export * from "./TypeEdit.vue?vue&type=script&lang=js"
import style0 from "./TypeEdit.vue?vue&type=style&index=0&id=174fd462&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "174fd462",
  null
  
)

export default component.exports